export default __webpack_public_path__ + "static/media/market2.4967536c.jpg";